import React from "react";
import classes from "./Button.module.css";

const Button = ({text,onPress,style}) => {
  return <button className={classes.btn} style={style} onClick={onPress}>{text}</button>;
};

export default Button;
